import { render, staticRenderFns } from "./profit.vue?vue&type=template&id=0a9757ca&scoped=true&"
import script from "./profit.vue?vue&type=script&lang=js&"
export * from "./profit.vue?vue&type=script&lang=js&"
import style0 from "./profit.vue?vue&type=style&index=0&id=0a9757ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9757ca",
  null
  
)

export default component.exports